import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Button,
  Loader,
} from "arv-reactcomponents";

import { ADD_NEFT_FORM } from "npmlinks-constants";
import AccountNumberInput from "../AccountNumberInput";
import UserNameInput from "../../../pages/ContactUs/V2/UserNameInput";
import IFSCCodeInput from "../IFSCCodeInput";
import AccountRadioTypeInput from "../AccountRadioTypeInput";
import BackButton from "../../BackButton";

@inject("ReturnStore", "CommonStore")
@observer
class AddNEFT extends Component {
  static renderLoader() {
    return (
      <div className="nw-bodyoverlay">
        <div className="nw-bodyoverlay-loadercontainer">
          <Loader />
        </div>
      </div>
    );
  }
  constructor(props) {
    super(props);

    this.state = {
      accountHolderName: "",
      accNameIsValid: false,
      bankName: "",
      bankNameIsValid: false,
      accountNumber: "",
      accNumberIsValid: false,
      confirmAccountNumber: "",
      conAccNumberIsValid: false,
      conAccNumberErrMsg: "",
      branchName: "",
      branchNameIsValid: false,
      ifscCode: "",
      ifscCodeIsValid: false,
      savingsAccount: true,
      currentAccount: false,
      isLoader: false,
      addneftErrorMsg: "",
      enableMargin: false,
    };

    this.handleAccountHolderName = this.handleAccountHolderName.bind(this);
    this.handleBankName = this.handleBankName.bind(this);
    this.handleAccountNumber = this.handleAccountNumber.bind(this);
    this.handleConfirmAccountNumber = this.handleConfirmAccountNumber.bind(
      this,
    );
    this.handleBranchName = this.handleBranchName.bind(this);
    this.handleIFSCCode = this.handleIFSCCode.bind(this);
    this.handleAccountType = this.handleAccountType.bind(this);
    this.handleNEFTData = this.handleNEFTData.bind(this);
    this.focus = this.focus.bind(this);
    this.blur = this.blur.bind(this);
  }

  handleAccountHolderName(input) {
    this.setState({
      accountHolderName: input.value,
      accNameIsValid: input.isValid,
      addneftErrorMsg: "",
    });
  }

  handleBankName(input) {
    this.setState({
      bankName: input.value,
      bankNameIsValid: input.isValid,
      addneftErrorMsg: "",
    });
  }

  handleAccountNumber(input) {
    this.setState(
      {
        accountNumber: input.value,
        accNumberIsValid: input.isValid,
        addneftErrorMsg: "",
      },
      () => {
        this.checkConfirmAccNum;
      },
    );
  }

  handleConfirmAccountNumber(input) {
    this.setState(
      {
        confirmAccountNumber: input.value,
        conAccNumberIsValid: input.isValid,
        addneftErrorMsg: "",
      },
      () => {
        this.checkConfirmAccNum;
      },
    );
  }

  handleBranchName(input) {
    this.setState({
      branchName: input.value,
      branchNameIsValid: input.isValid,
      addneftErrorMsg: "",
    });
  }

  handleIFSCCode(input) {
    this.setState({
      ifscCode: input.value,
      ifscCodeIsValid: input.isValid,
      addneftErrorMsg: "",
    });
  }

  handleAccountType() {
    this.setState({
      savingsAccount: !this.state.savingsAccount,
      currentAccount: !this.state.currentAccount,
      addneftErrorMsg: "",
    });
  }

  get accountNature() {
    const { savingsAccount, currentAccount } = this.state;
    return savingsAccount
      ? ADD_NEFT_FORM.savingsAccountNature
      : ADD_NEFT_FORM.currentAccountNature;
  }

  handleNEFTData(e) {
    e.preventDefault();
    const {
      accountHolderName,
      bankName,
      accountNumber,
      branchName,
      ifscCode,
    } = this.state;
    const NEFT_DATA = {
      accountNature: this.accountNature,
      accountNumber,
      bankName,
      branchName,
      customerName: accountHolderName,
      ifscCode,
    };
    this.setState({ isLoader: true });
    this.props.ReturnStore.addNEFTDetails(NEFT_DATA).then(
      () => {
        this.setState({ isLoader: false });
        console.log("Response from add  Neft API");
        this.props.next();
      },
      err => {
        const { data } = err;
        if (data) {
          const { message = ADD_NEFT_FORM.default_error_msg } = data;
          this.setState({ isLoader: false, addneftErrorMsg: message });
        } else {
          this.setState({
            isLoader: false,
            addneftErrorMsg: ADD_NEFT_FORM.default_error_msg,
          });
        }
      },
    );
  }
  focus(e) {
    const { isDesktop } = this.props.CommonStore;
    e.persist();
    if (!isDesktop) {
      this.setState({ enableMargin: true }, function () {
        setTimeout(() => {
          e.target.scrollIntoView({ block: "start" });
        }, 0)
      });
    }
  }
  blur(e) {
    this.setState({ enableMargin: false });
  }

  get marginStyle() {
    return this.state.enableMargin ? "nw-section-mobile" : "";
  }
  get checkConfirmAccNum() {
    const { accountNumber, confirmAccountNumber } = this.state;
    if (!accountNumber || !confirmAccountNumber) {
      this.setState({
        conAccNumberErrMsg: "",
        conAccNumberIsValid: false,
      });
      return;
    }
    if (accountNumber !== confirmAccountNumber) {
      this.setState({
        conAccNumberErrMsg: ADD_NEFT_FORM.conAccNumErrMsg,
        conAccNumberIsValid: false,
      });
    } else {
      this.setState({
        conAccNumberErrMsg: "",
        conAccNumberIsValid: true,
      });
    }
  }

  get isSubmitButtonEnable() {
    const {
      accNameIsValid,
      bankNameIsValid,
      accNumberIsValid,
      conAccNumberIsValid,
      branchNameIsValid,
      ifscCodeIsValid,
    } = this.state;
    return (
      accNameIsValid &&
      bankNameIsValid &&
      accNumberIsValid &&
      conAccNumberIsValid &&
      branchNameIsValid &&
      ifscCodeIsValid
    );
  }

  render() {
    const {
      accountHolderName,
      bankName,
      accountNumber,
      confirmAccountNumber,
      branchName,
      ifscCode,
      savingsAccount,
      currentAccount,
      conAccNumberErrMsg,
      isLoader,
      addneftErrorMsg,
    } = this.state;

    const submitEnable = this.isSubmitButtonEnable;

    return (
      <GridContainer className="nw-addneft-wrapper">
        {isLoader && AddNEFT.renderLoader()}
        <form
          className="nw-addneft-form"
          name="NEFT_FORM"
          id="NEFT_FORM"
          onSubmit={this.handleNEFTData}
        >
          <BackButton.component
            previous={this.props.previous}
            className="nw-returnneft-backbtn"
          />
          <h2 className="nw-returns-title"> Add NEFT Details </h2>
          <section className={`nw-addneft-blockwrapper ${this.marginStyle}`}>
            <GridRow className="nw-addneft-block">
              <GridColumn className="nwc-grid-col-sm nw-returns-inputblock">
                <div className="nw-returns-label">
                  {" "}
                  {ADD_NEFT_FORM.accHoldName}{" "}
                </div>
                <UserNameInput.component
                  className="nwc-inp-secondary nw-returns-input"
                  name="accountHolderName"
                  id="accountHolderName"
                  placeholder=""
                  text={accountHolderName}
                  validateUserNameInput={this.handleAccountHolderName}
                  minCharErrMsg={ADD_NEFT_FORM.minCharAccHoldNameErrMsg}
                  invalidErrMsg={ADD_NEFT_FORM.invalidNameErrMsg}
                  errorMsgClassName="nw-addneft-formerror"
                />
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm nw-returns-inputblock">
                <div className="nw-returns-label">
                  {" "}
                  {ADD_NEFT_FORM.bankName}{" "}
                </div>
                <UserNameInput.component
                  className="nwc-inp-secondary nw-returns-input"
                  name="bankName"
                  id="bankName"
                  placeholder=""
                  text={bankName}
                  validateUserNameInput={this.handleBankName}
                  minCharErrMsg={ADD_NEFT_FORM.minCharbankNameErrMsg}
                  invalidErrMsg={ADD_NEFT_FORM.invalidNameErrMsg}
                  errorMsgClassName="nw-addneft-formerror"
                />
              </GridColumn>
            </GridRow>
            <GridRow className="nw-addneft-block">
              <GridColumn className="nwc-grid-col-sm nw-returns-inputblock">
                <div className="nw-returns-label">
                  {" "}
                  {ADD_NEFT_FORM.accNumber}{" "}
                </div>
                <AccountNumberInput.component
                  className="nwc-inp-secondary nw-returns-input"
                  name="accountNumber"
                  id="accountNumber"
                  placeholder=""
                  text={accountNumber}
                  validateAccountNumberInput={this.handleAccountNumber}
                  errorMsgClassName="nw-addneft-formerror"
                  onFocus={this.focus}
                  onBlur={this.blur}
                />
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm nw-returns-inputblock">
                <div className="nw-returns-label">
                  {" "}
                  {ADD_NEFT_FORM.conAccNumber}{" "}
                </div>
                <AccountNumberInput.component
                  className="nwc-inp-secondary nw-returns-input"
                  name="confirmAccountNumber"
                  id="confirmAccountNumber"
                  placeholder=""
                  text={confirmAccountNumber}
                  validateAccountNumberInput={this.handleConfirmAccountNumber}
                  errorMsgClassName="nw-addneft-formerror"
                  confirmErrorMsg={conAccNumberErrMsg}
                  onFocus={this.focus}
                  onBlur={this.blur}
                />
              </GridColumn>
            </GridRow>
            <GridRow className="nw-addneft-block">
              <GridColumn className="nwc-grid-col-sm nw-returns-inputblock">
                <div className="nw-returns-label">
                  {" "}
                  {ADD_NEFT_FORM.branchName}{" "}
                </div>
                <UserNameInput.component
                  className="nwc-inp-secondary nw-returns-input"
                  name="branchName"
                  id="branchName"
                  placeholder=""
                  text={branchName}
                  validateUserNameInput={this.handleBranchName}
                  minCharErrMsg={ADD_NEFT_FORM.minCharbranchNameErrMsg}
                  invalidErrMsg={ADD_NEFT_FORM.invalidNameErrMsg}
                  errorMsgClassName="nw-addneft-formerror"
                  onFocus={this.focus}
                  onBlur={this.blur}
                />
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm nw-returns-inputblock">
                <div className="nw-returns-label"> {ADD_NEFT_FORM.ifsc} </div>
                <IFSCCodeInput.component
                  className="nwc-inp-secondary nw-returns-input"
                  name="ifscCode"
                  id="ifscCode"
                  placeholder=""
                  text={ifscCode}
                  validateIFSCInput={this.handleIFSCCode}
                  errorMsgClassName="nw-addneft-formerror"
                  onFocus={this.focus}
                  onBlur={this.blur}
                />
              </GridColumn>
            </GridRow>
            <GridRow className="nw-addneft-block">
              <GridColumn className="nw-addneft-radiotitle nw-returns-label">
                {" "}
                {ADD_NEFT_FORM.accTypeTitle}{" "}
              </GridColumn>
              <GridColumn className="nw-addneft-radioblock nw-returns-inputblock">
                <div className="nw-addneft-radioinput">
                  <AccountRadioTypeInput.component
                    className="nw-addneft-radio"
                    name="savingsAccount"
                    id="savingsAccount"
                    checked={savingsAccount}
                    handleToggle={this.handleAccountType}
                  />
                  <div className="nw-addneft-radiolabel">
                    {" "}
                    {ADD_NEFT_FORM.savingsAccType}{" "}
                  </div>
                </div>
                <div className="nw-addneft-radioinput">
                  <AccountRadioTypeInput.component
                    className="nw-addneft-radio"
                    name="currentAccount"
                    id="currentAccount"
                    checked={currentAccount}
                    handleToggle={this.handleAccountType}
                  />
                  <div className="nw-addneft-radiolabel">
                    {" "}
                    {ADD_NEFT_FORM.currentAccType}{" "}
                  </div>
                </div>
              </GridColumn>
            </GridRow>
            <GridRow>
              <GridColumn className="nw-returns-buttonblock">
                <Button
                  className="nwc-btn-primary nw-returns-button"
                  id="addNeftSave"
                  onClick={this.handleNEFTData}
                  disabled={!submitEnable}
                >
                  {ADD_NEFT_FORM.submitButton}
                </Button>
                {addneftErrorMsg && (
                  <div className="nw-addneft-errormsg">{addneftErrorMsg}</div>
                )}
              </GridColumn>
            </GridRow>
          </section>
        </form>
      </GridContainer>
    );
  }
}

AddNEFT.wrappedComponent.propTypes = {
  next: PropTypes.func,
  previous: PropTypes.func,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("ReturnStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: AddNEFT.wrappedComponent,
  component: AddNEFT,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ReturnComponent/AddNEFT/index.js